import { currentUserInfoMixin, tenantInfoMixin } from '../../js/custom-vue-mixins';
import { FormatDateTimeLocal } from '../../js/filters-helpers';
// a MIXIN to use in the various 'inner task content' components
// things that are inside FlowNode.vue 

// TODO - change name to NodeContentMixin

export default {
    components: {},
    mixins: [
        currentUserInfoMixin,  // mixins in mixins?  whoa
        tenantInfoMixin,
    ],
    props: {
        flowObjectClass: {  // need this so we can pass to children if needed
            type: String,
            required: true,
        },
        flowSubtype: {
            type: String,
            default: null,
        },
        nodeData: {  // pass in from localNodeData in Task component so its got all the detail
            type: Object,
            required: true,
        },
        nodeContext: {  // node-level context, with info/methods on calling transitions
            type: Object,
            required: true,  
        },
    },
    data() {
        return {
            // ??? anything
        }
    },
    computed: {  // pull out things from nodeData/nodeContext for convenience
        flowObjectId() {
            return this.nodeContext.flowObjectId;
        },
        nodeKey() {
            return this.nodeContext.nodeKey;
        },
        nodeType() {
            return this.nodeData.node_type;
        },
        nodeTransitions() {
            return this.nodeContext ? this.nodeContext.nodeTransitions : [];
        },
        nodeTriggers() {
            return this.nodeContext ? this.nodeContext.nodeTriggers : [];
        },
        loadingTransition() {
            return this.nodeContext ? this.nodeContext.loadingTransition : false;
        },
        loadingNode() {
            // is the node DETAIL loading?  (fetched in FlowNode.vue, passed down via nodeContext)
            // this will be false even if we don't have node detail yet... so use hasNodeDetail for that
            return this.nodeContext ? this.nodeContext.loadingNode : false;
        },
        hasNodeDetail() {
            // do we have the nodeDetail in nodeData?  (fetched in FlowNode.vue, passed down via nodeContext)
            return this.nodeContext ? this.nodeContext.hasNodeDetail : false;
        },
        flowContext() {
            return this.nodeContext ? this.nodeContext.flowContext : {};
        },
        // TASK STATE 
        wasStarted() {
            return this.nodeData.was_started;
        },
        isWaiting() {
            // might have to adjust this as you make other node types...
            // for now, if NOT started yet, and NOT editable, then it's waiting
            // because we have some node types that never get started until just in time, but are still editable (update_form)
            return !this.wasStarted && !this.isEditable && !this.isSkipped;
        },
        isActive() {
            return this.nodeData.is_active;
        },
        isCompleted() {
            return this.nodeData.is_completed;
        },
        isSkipped() {
            return this.nodeData.is_skipped;
        },
        isExpired() {
            return this.nodeData.is_expired;
        },
        isEditable() {
            return this.nodeData.is_editable;
        },
        title() {
            return this.nodeData.title;
        },
        // datetimes - with formatting 
        started() {
            return this.nodeData.started;
        },
        startedFormatted() {
            return FormatDateTimeLocal(this.started);
        },
        completed() {
            return this.nodeData.completed;
        },
        completedFormatted() {
            return FormatDateTimeLocal(this.completed);
        },
        // ASSIGNEE / ROLE RELATED
        assignedTus() {
            return this.nodeData.assigned_tus;  // array of objects
        },
        assignedTuIds() {  
            return this.nodeData.assigned_tus.map(atu => atu.id);  // array of IDs for now
        },
        isAssignee() {
            return this.assignedTuIds.includes(this.$currentUserInfo.tenant_user_id);
        },
    },
    //mounted() {},
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        startTransition(triggerName) {
            this.nodeContext.startTransition(triggerName);  // opens modal to confirm
        },
        toSummary() {
            // route back to the 'summary' tab immediately 
            if (this.flowContext?.toSummary) {
                this.flowContext.toSummary();
            }
        },
        emitUpdated(payload) {
            // put various $emit() methods on mixin so they all have consistent format 
            // payload is likely not being used yet... figure out how to do it...
            // not all task content instances will use this
            this.$emit('updated', payload);
        },
        async beforeCallTransition({transition, data}) {
            // CALLED FROM PARENT - FlowNode
            // after the user clicks 'confirm' when callingn a transtion, but before the actual API call is made
            // this should always return a promise that resolves to boolean - True if OK to proceed, false if not
            // OVERRIDE THIS ON COMPONENTS THAT USE THIS MIXIN - but make sure the signature/return structure are SAME
            // params passed in are the transition object ('transition') and any payload data that will be sent in the API call ('data')
            // you can get the trigger name to check if you care about the transition from 'transition.trigger'
            // ONE PLACE TO USE THIS -- in task forms -- to trigger forms to submit themselves if save_behavior is 'submit' 
            // you don't want to call that before user clicks "confirm" to submit
            // but other places may not need this -- just return Promise.resolve(true) for those and no need to override where this is used then
            console.log(`from nodeKey ${this.nodeKey} - IN MIXIN - beforeCallTransition -- will call transition with payload data`, transition, data);
            return true;  //return Promise.resolve(true);  // don't need Promise.resolve() because we have aysnc 
        }
    },
};
